export default {"src":"/_next/static/media/send.9d898542.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};